module.exports = __webpack_public_path__ + "img/dotsK.38a87f54.png";